import { render, staticRenderFns } from "./LearningVideo.vue?vue&type=template&id=465a5338&scoped=true"
import script from "./LearningVideo.vue?vue&type=script&lang=js"
export * from "./LearningVideo.vue?vue&type=script&lang=js"
import style0 from "./LearningVideo.vue?vue&type=style&index=0&id=465a5338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465a5338",
  null
  
)

export default component.exports